import React, { useEffect } from 'react'
import { FlagsIconSeeker, SelectSeeker } from "@ui-seeker/core"
import { Box, Typography } from "@mui/material"
import { officeModalData } from "@signals"
import { translateCountryName } from "@ui-seeker/utils"

export default function ModalCountriesSelector({ applyFilters, countriesOptions, onChangeCountry }) {

	const options = Array.from(new Set(officeModalData.value.map(({ country }) => country))).map(country => ({
		value: country,
		label: (
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: .5 }}>
				<FlagsIconSeeker countryName={country}/>
				<Typography>{translateCountryName(country)}</Typography>
			</Box>
		)
	}))

	useEffect(() => {
		applyFilters()
	}, [countriesOptions])

	return <SelectSeeker
		multiple
		label="Filter office country"
		placeholder="All countries"
		value={countriesOptions}
		onChange={onChangeCountry}
		isClearable
		options={options}
	/>
}